import React from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { getConfig } from 'configs';
import styled from 'styled-components';
import { breakpoint } from 'styled-components-breakpoint';
import { ListItemData } from '../utils/mapData';

const containerStyle = {
  width: '100%',
  height: '100%',
};

const MapWrapper = styled.div`
  height: 400px;
  margin-top: 1rem;
  width: 100%;

  ${breakpoint('desktop')`
    height: 100%;
    min-height: 400px;
    margin-top: 0px;
    width: initial;
  `}
`;

interface GoogleMapProps {
  location?: google.maps.LatLngLiteral;
  data?: ListItemData[];
  handleOnMarkerClick: (rowId: number | string | undefined) => void;
}

const config = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'mock');

const CustomGoogleMap = ({ location, data, handleOnMarkerClick }: GoogleMapProps) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: config.googleMapApiKey,
  });

  return isLoaded ? (
    <MapWrapper>
      <GoogleMap mapContainerStyle={containerStyle} center={location} zoom={15}>
        {data?.map((item) => {
          return (
            <Marker
              key={item.itemId ?? 0}
              position={{ lat: item.latitude ?? 0, lng: item.longitude ?? 0 }}
              onClick={() => handleOnMarkerClick(item.itemId ?? -1)}
            />
          );
        })}
      </GoogleMap>
    </MapWrapper>
  ) : (
    <></>
  );
};

export default CustomGoogleMap;
